export enum CouponBenefitType {
  CashOff = 'cash_off',
  PercentOff = 'percent_off',
  FreeService = 'free_service',
  FreeItem = 'free_item',
  GiftOnPurchase = 'gift_on_purchase',
}
export type CouponBenefit =
  | {
      type: CouponBenefitType.CashOff;
      amount: number;
      minSpend?: number;
      appliesTo?: string[];
    }
  | {
      type: CouponBenefitType.PercentOff;
      percent: number;
      maxDiscount?: number;
      appliesTo?: string[];
    }
  | { type: CouponBenefitType.FreeService; serviceName: string }
  | { type: CouponBenefitType.FreeItem; itemName: string }
  | { type: CouponBenefitType.GiftOnPurchase; buy: string; get: string };
export interface CouponCampaignPublicViewItem {
  label: string;
  benefit: CouponBenefit;
  qty: number;
  qtyUnit: string | null;
}
export interface CouponRecipientQrInput {
  couponCampaignId: string;
  recipientToken: string;
}
export interface ApdmPlateCouponItem extends CouponCampaignPublicViewItem {
  itemId: string;
  remainingQty: number;
  redeemedQty: number;
  nextCouponId: string | null;
  /** The usable coupons in the order they are redeemed. */
  claimableCouponIds: string[];
}
export enum ApdmPlateCouponState {
  Usable = 'usable',
  UsedUp = 'used_up',
  Expired = 'expired',
}
export interface ApdmPlateCouponItemsResult {
  couponCampaignId: string;
  state: ApdmPlateCouponState;
  licensePlateNo: string;
  customerName: string | null;
  campaignTitle: string;
  /** When the first usable coupon expires; null when none expires. */
  expiresAt: string | null;
  items: ApdmPlateCouponItem[];
}
export interface ApdmPlateCouponBatchRedeemLine {
  itemId: string;
  /** The exact coupons to use: the item's first claimable ones. */
  couponIds: string[];
}
/** Several items of one coupon redeemed together: all of them or none. */
export interface ApdmPlateCouponBatchRedeemInput
  extends CouponRecipientQrInput {
  /** Made once per batch and resent unchanged on a retry. */
  requestId: string;
  lines: ApdmPlateCouponBatchRedeemLine[];
}
/** The server's limits on one batch. */
export const kApdmPlateCouponBatchMaxLines = 20;
export const kApdmPlateCouponBatchMaxCoupons = 50;
export enum ApdmPlateCouponBatchRedeemOutcome {
  Redeemed = 'redeemed',
  /** Every coupon was already redeemed: a retry of a batch that landed. */
  Replayed = 'replayed',
  /** The coupons differ from what was shown; nothing was redeemed. */
  Changed = 'changed',
}
export type ApdmPlateCouponBatchRedeemResult = {
  couponCampaignId: string;
} & (
  | {
      outcome:
        | ApdmPlateCouponBatchRedeemOutcome.Redeemed
        | ApdmPlateCouponBatchRedeemOutcome.Replayed;
      redeemedAt: string;
      lines: ApdmPlateCouponBatchRedeemLine[];
    }
  | { outcome: ApdmPlateCouponBatchRedeemOutcome.Changed }
);
